module.exports = __webpack_public_path__ + "static/teddybike3-98e7a4b71a382339e03b4758c6469aee.png";